<template slot="content">
  <dialog-v2
    :title="title"
    :show="show"
    :disable-save-btn="errors.any() || metaTemplatesVariables.length === 0"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex md12>
            <v-text-field
              v-model="form.name"
              v-validate="'required'"
              data-vv-name="name_template"
              data-vv-as="nombre"
              data-vv-scope="whatsappTemplate"
              :error-messages="errors.collect('whatsappTemplate.name_template')"
              label="Nombre"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md12>
            <v-select
              v-model="form.template_channel"
              :items="phones"
              :disabled="isLoading"
              item-value="instance_id"
              item-text="full_phone"
              label="Teléfono"
              color="black"
              v-validate="'required'"
              data-vv-scope="whatsappTemplate"
              data-vv-name="phone"
              data-vv-as="teléfono"
              :error-messages="errors.collect('whatsappTemplate.phone')"
              @input="getMetaTemplates"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md12>
            <v-select
              v-model="form.key"
              :items="metaTemplates"
              :disabled="!metaTemplates.length"
              item-value="id"
              item-text="name"
              label="Identificador"
              color="black"
              v-validate="'required'"
              data-vv-scope="whatsappTemplate"
              data-vv-name="key"
              data-vv-as="identificador"
              :error-messages="errors.collect('whatsappTemplate.key')"
              @input="setMetaTemplatesVariables"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="!!selectedMetaTemplateTextRaw">
          <v-flex md12>
            <pre>{{ selectedMetaTemplateTextRaw }}</pre>
            <small class="text--red" v-if="metaTemplatesVariables.length === 0">
              La plantilla debe contener al menos una variable.
            </small>
          </v-flex>
        </v-layout>
        <v-layout row wrap :key="variable.label" v-for="variable in metaTemplatesVariables">
          <v-flex :md4="!isUrlActive" :md6="isUrlActive" class="align-self-center">
            <h3 class="text-subtitle-1">
              <span v-pre>{{</span>{{ variable.label }}<span v-pre>}}</span>
            </h3>
          </v-flex>
          <v-flex :md4="!isUrlActive" :md6="isUrlActive" class="align-self-center">
            <v-select
              v-model="variable.value"
              :items="templateVars"
              label="Mapear a"
              color="black"
              autocomplete
              v-validate="'required'"
              data-vv-scope="whatsappTemplate"
              :data-vv-name="variable.label"
              :data-vv-as="variable.label"
              :error-messages="errors.collect(`whatsappTemplate.${variable.label}`)"
            />
          </v-flex>
          <v-flex md4 v-if="variable.value === 'url'" class="align-self-center">
            <v-text-field
              v-model="variable.url"
              label="URL"
              color="black"
              v-validate="'required|url'"
              data-vv-scope="whatsappTemplate"
              hint="Los links redireccionaran a esta url"
              :persistent-hint="true"
              :data-vv-name="`${variable.label}_url`"
              :data-vv-as="'URL'"
              :error-messages="errors.collect(`whatsappTemplate.${variable.label}_url`)"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </dialog-v2>
</template>

<script>
import EventBus from '@/event-bus';
import FiltersMixin from '@/mixins/workflowFilters';
import DialogV2 from '@/components/global/DialogV2';

export default {
  inject: ['$validator'],
  mixins: [
    FiltersMixin,
  ],
  components: {
    DialogV2,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    whatsappTemplate: {
      type: Object,
      default: () => ({}),
    },
    phones: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      isLoading: false,
      selectedTemplateChannel: null,
      metaTemplates: [],
      metaTemplatesVariables: [],
      form: {
        key: '',
        name: '',
        template_channel: '',
      },
    };
  },
  computed: {
    title() {
      if (this.whatsappTemplate.id) {
        return 'Editar plantilla de whatsapp'
      }
      return 'Crear plantilla de whatsapp';
    },
    isUrlActive() {
      return !(this.metaTemplatesVariables.some((variable) => variable.value === 'url'));
    },
    selectedMetaTemplate() {
      return this.metaTemplates.find((template) => template.id === this.form.key) || {};
    },
    selectedMetaTemplateTextRaw() {
      if (!this.form.key) {
        return '';
      }

      if (!Object.keys(this.selectedMetaTemplate).length) {
        return '';
      }

      let text = this.selectedMetaTemplate
        .components
        .map((template) => template.text)
        .join('\n');

      if (!this.metaTemplatesVariables.length) {
        return text;
      }

      for (let i = 0; i < this.metaTemplatesVariables.length; i += 1) {
        text = text.replace(`{{${i + 1}}}`, `{{${this.selectedMetaTemplate.parameters[i].name}}}`);
      }

      return text;
    },
    selectedMetaTemplateText() {
      if (!this.form.key) {
        return '';
      }

      if (!Object.keys(this.selectedMetaTemplate).length) {
        return '';
      }

      let text = this.selectedMetaTemplate
        .components
        .map((template) => template.text)
        .join('\n');

      if (!this.metaTemplatesVariables.length) {
        return text;
      }

      for (let i = 0; i < this.metaTemplatesVariables.length; i += 1) {
        text = text.replace(`{{${i + 1}}}`, `@${this.metaTemplatesVariables[i].value}`);
      }

      return text;
    },
  },
  methods: {
    clearData() {
      this.selectedTemplateChannel = null;
      this.metaTemplates = [];
      this.metaTemplatesVariables = [];
      this.form = {
        key: '',
        name: '',
        template_channel: '',
      };
    },
    getMetaTemplates(initVariables = false) {
      this.errors.removeById('disabled_phone');
      this.metaTemplates = [];
      this.metaTemplatesVariables = [];
      this.isLoading = true;
      this.axios.get(`whatsapp_templates/${this.form.template_channel}/meta_templates`)
        .then(({ data }) => {
          this.metaTemplates = data;
          this.setMetaTemplatesVariables(this.form.key, initVariables);
        })
        .catch((error) => {
          console.error(error);
          EventBus.$emit('error', 'Ocurrio un error al obtener las plantillas de Tikket');
          this.$emit('close');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setMetaTemplatesVariables(key, initVariables) {
      if (!((this.selectedMetaTemplate || {}).parameters || []).length) {
        return this.$set(this, 'metaTemplatesVariables', []);
      }

      const variables = this.selectedMetaTemplate.parameters.map((variable, index) => {
        const value = initVariables ? this.whatsappTemplate.text.custom_parameters[index] : '';

        return {
          label: variable.name,
          value,
        };
      });

      if (((this.whatsappTemplate.text || {}).urls || []).length) {
        variables.filter((variable) => variable.value === 'url').forEach((variable, index) => {
          variable.url = this.whatsappTemplate.text.urls[index];
        });
      }
      this.$set(this, 'metaTemplatesVariables', variables);
    },
    async save() {
      const validation = await this.$validator.validateAll('whatsappTemplate');
      if (!validation) {
        return;
      }

      const httpMethod = this.whatsappTemplate.id ? 'patch' : 'post';
      const httpUrl = this.whatsappTemplate.id ? `whatsapp_templates/${this.whatsappTemplate.id}` : 'whatsapp_templates';

      this.axios[httpMethod](httpUrl, {
        ...this.form,
        text: JSON.stringify({
          value:             this.selectedMetaTemplateText,
          urls:              this.metaTemplatesVariables.filter(item => item.value === 'url').map(item => item.url),
          custom_parameters: this.metaTemplatesVariables.map((item) => item.value),
          approved_tikket_text: this.selectedMetaTemplateTextRaw,
        }),
      }).then(() => {
        this.$emit('saved');
        this.$emit('close');
      })
      .catch((error) => {
        console.error(error);
        EventBus.$emit('error', 'Ocurrio un error al guardar la plantilla');
      });
    },
  },
  watch: {
    show(val) {
      this.clearData();
      this.$validator.reset();
      this.errors.clear();

      if (!val) {
        return;
      }

      this.form = {
        key:              this.whatsappTemplate.key,
        name:             this.whatsappTemplate.name,
        template_channel: this.whatsappTemplate.template_channel,
      };

      if (typeof this.whatsappTemplate.text === 'string') {
        this.whatsappTemplate.text = JSON.parse(this.whatsappTemplate.text);
      }

      if (this.form.template_channel) {
        this.getMetaTemplates(!!(this.whatsappTemplate.text || {}).custom_parameters);
      }

      if (!!this.whatsappTemplate.template_channel && !this.phones.find(phone => phone.instance_id === this.whatsappTemplate.template_channel)) {
        this.form.template_channel = '';
        this.errors.add({
          id: 'disabled_phone',
          field: 'whatsappTemplate.phone',
          msg: 'Teléfono deshabilitado. Ingresa un nuevo número de teléfono.',
        });
      }
    },
  },
};
</script>

<style scoped>
pre {
  white-space: pre-wrap;
  overflow-x: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/WhatsappTemplates/SaveWhatsappTemplateDialog.vue